import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import IconArrow from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '1280px',
    backgroundColor: [
      'inherit',
      'inherit',
      defaultTheme.background.white,
      defaultTheme.background.white,
    ],
    padding: [0, 0, '32px 80px', '32px 80px'],
  }),
);

export const AreaWrapper = styled.div(() =>
  mq({
    backgroundColor: [
      defaultTheme.background.white,
      defaultTheme.background.white,
      'inherit',
      'inherit',
    ],
    padding: [defaultTheme.spacing.l, defaultTheme.spacing.l, 0, 0],
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      '32px',
      '32px',
    ],
  }),
);

export const AreaName = styled.h2(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    borderBottom: `1px solid ${defaultTheme.border.color.darkGray}`,
    paddingBottom: defaultTheme.spacing.s,
    marginBottom: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const Velodromes = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(3, 1fr)',
      'repeat(4, 1fr)',
    ],
    gridGap: [
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.xxl} 57px`,
      `${defaultTheme.spacing.xxl} 57px`,
    ],
  }),
);

export const VelodromeLink = styled(Link)(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    borderBottom: [
      `1px solid ${defaultTheme.border.color.lightGray}`,
      `1px solid ${defaultTheme.border.color.lightGray}`,
      'none',
      'none',
    ],
    paddingBottom: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      0,
    ],
    ...hoverOpacity,
    '&::after': {
      content: '""',
      width: '14px',
      height: '14px',
      backgroundImage: `url(${IconArrow})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  }),
);

export const VelodromeNameWrapper = styled.div(() =>
  mq({
    '> span': {
      display: 'inline-block',
    },
  }),
);
